import { useSuspenseQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc/client";

export const useGetUserStudySetRating = (id: string) => {
  const trpc = useTRPC();
  return useSuspenseQuery(
    trpc.studysets.getUserRating.queryOptions(
      {
        id,
      },
      {
        staleTime: Number.POSITIVE_INFINITY,
      },
    ),
  );
};
